import BackButton from "@dashboard/components/BackButton";
import { ConfirmButton } from "@dashboard/components/ConfirmButton";
import { DashboardModal } from "@dashboard/components/Modal";
import { Text } from "@saleor/macaw-ui-next";
import React from "react";
import { FormattedMessage } from "react-intl";

import { useDeleteInquiryFormMutation } from "../hooks";

interface InquiryFormDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  form?: {
    id: string;
    title: string;
  };
}

const InquiryFormDeleteDialog: React.FC<InquiryFormDeleteDialogProps> = ({
  open,
  onClose,
  onSuccess,
  form,
}) => {
  const [deleteInquiryForm, { loading }] = useDeleteInquiryFormMutation();

  const handleSubmit = async () => {
    if (!form?.id) return;

    try {
      await deleteInquiryForm({
        variables: {
          id: form.id,
        }
      });

      onSuccess();
    } catch (error) {
      console.error("Error deleting inquiry form:", error);
    }
  };

  return (
    <DashboardModal onChange={onClose} open={open}>
      <DashboardModal.Content size="sm">
        <DashboardModal.Header>
          <FormattedMessage
            id="RdRlO0"
            defaultMessage="Delete Inquiry Form"
          />
        </DashboardModal.Header>

        <Text>
          <FormattedMessage
            id="vrmApj"
            defaultMessage="Are you sure you want to delete {name}? This action cannot be undone."
            values={{
              name: <strong>{form?.title}</strong>,
            }}
          />
        </Text>

        <DashboardModal.Actions>
          <BackButton onClick={onClose} />
          <ConfirmButton
            variant="error"
            onClick={handleSubmit}
            disabled={loading}
            transitionState={loading ? "loading" : "default"}
          >
            <FormattedMessage id="K3r6DQ" defaultMessage="Delete" />
          </ConfirmButton>
        </DashboardModal.Actions>
      </DashboardModal.Content>
    </DashboardModal>
  );
};

export default InquiryFormDeleteDialog;